// extracted by mini-css-extract-plugin
export default {"container":"style_container__3XFzL","logo_txt":"style_logo_txt__oR4gm","pourcentage":"style_pourcentage__tZBlc","show":"style_show__fXofC","hide":"style_hide__k9NqR"};